import {React, useContext, useEffect} from 'react';
import { format } from 'date-fns'; // import date-fns for date formatting
import { useLocation } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';

const OpenRequest = () => {
    const location = useLocation();
    const { openRequest } = location.state || { openRequest: {} };
    const { items, zone, status, date } = openRequest;
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user]) 


    const getStatusColor = (status) => {
        switch (status) {
            case 'pending':
                return 'bg-yellow-500';
            case 'approved':
                return 'bg-green-500';
            case 'rejected':
                return 'bg-red-500';
            default:
                return 'bg-gray-500';
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="bg-white rounded shadow p-4">
                <h2 className="text-xl font-semibold mb-4 text-fmb">Request Details</h2>
                <div>
                    <p className="text-gray-600 mb-2">Zone: {zone}</p>
                    <p className="text-gray-600 mb-2">Status: <span className={`px-2 py-1 rounded ${getStatusColor(status)} text-white`}>{status}</span></p>
                    <p className="text-gray-600 mb-2">Date: <span className="text-sm">{format(new Date(date), 'MM/dd/yyyy')}</span></p>
                </div>
                <div className="mt-4">
                    <h3 className="text-lg font-semibold mb-2 text-fmb">Items</h3>
                    {items.map((item, index) => (
                        <div key={index} className="border-b border-gray-200 pb-2 mb-2">
                            <p className="text-gray-600 mb-1">{item.item.name}</p>
                            <p className="text-gray-600">Quantity: {item.quantity}</p>
                            <p className="text-gray-600">Status: <span className={`px-2 py-1 rounded ${getStatusColor(item.status)} text-white`}>{item.status}</span></p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OpenRequest;
